import DashboardCard from './dashboardCard'
export default DashboardCard
